module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4109@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4109%402x.png
// module id = 721Q
// module chunks = 93